import { submitMessageSettings } from './submitMessageSettings';

export const submitActionsSettings = {
  submitAction: 'message' as const,

  ...submitMessageSettings
};

export type SubmitActionsSettings = typeof submitActionsSettings;
